import { isObservable, isObservableMap } from 'mobx';
import { ComputedClass } from './Computed';
import { throwError, isObject } from 'cerebral/internal';
export function updateIn(obj, path, cb) {
    return path.reduce(function (currentValue, key, index) {
        if (index > 0 && currentValue === undefined) {
            throwError("You are setting to path \"" + path + "\", but it is not valid");
        }
        if (index === path.length - 1) {
            cb(currentValue, key);
        }
        return isObservableMap(currentValue)
            ? currentValue.get(key)
            : currentValue[key];
    }, obj);
}
export function traverse(obj, cb, path) {
    if (path === void 0) { path = []; }
    return Object.keys(obj).reduce(function (newObj, key) {
        var propertyDescriptor = Object.getOwnPropertyDescriptor(obj, key);
        if (propertyDescriptor && 'get' in propertyDescriptor) {
            Object.defineProperty(newObj, key, propertyDescriptor);
        }
        else if (isObservable(obj[key]) || obj[key] instanceof ComputedClass) {
            newObj[key] = obj[key];
        }
        else if (isObject(obj[key])) {
            path.push(key);
            newObj[key] = traverse(obj[key], cb, path);
            path.pop();
            newObj[key] = cb(newObj, key, path);
        }
        else {
            newObj[key] = cb(obj, key, path);
        }
        return newObj;
    }, {});
}
//# sourceMappingURL=utils.js.map


//////////////////
// WEBPACK FOOTER
// /home/kryd0s/tmp/widgetbot/node_modules/@cerebral/fluent/es/utils.js
// module id = 72
// module chunks = 0